import React, { Component } from "react";
import { scrollToTop } from "utils/dom";
import Button from "components/Button";
import IconHeader from "components/IconHeader";
import IconSubheader from "components/IconSubheader";
import SelectBox from "../../../../signUp/individual/SelectBox";

interface DistributionReasonItem {
  label: string;
  key: string;
  description: string;
  items?: React.ReactNode[];
  ordered?: boolean;
}

interface DistributionReasonProps {
  goToNamedStep?: (step: string) => void;
  onDistributionReasonSelect?: (distributionSpecialReason: string) => void;
  // react-step-wizard injects stepName at runtime; the workflows declare it
  // on the JSX element.
  stepName?: string;
}

interface DistributionReasonState {
  distributionSpecialReason: string;
}

const distributionReasons: DistributionReasonItem[] = [
  {
    label: "Disability",
    key: "DISABILITY",
    description:
      "If you're unable to work due to a long-term or terminal disability, you may avoid the 10% early withdrawal penalty on your IRA.",
  },
  {
    label: "None of the above apply to me",
    key: "NONE",
    description:
      "If this does not apply to you, you can proceed to the next step.",
  },
];

class DistributionReason extends Component<
  DistributionReasonProps,
  DistributionReasonState
> {
  constructor(props: DistributionReasonProps) {
    super(props);
    this.state = {
      distributionSpecialReason: "",
    };
  }

  componentDidMount() {
    scrollToTop();
  }

  _setDistributionReason = (distributionSpecialReason: string) => {
    this.setState({ distributionSpecialReason }, () => {
      if (this.props.onDistributionReasonSelect) {
        this.props.onDistributionReasonSelect(distributionSpecialReason);
      }
    });
  };

  render() {
    const articleStyle = { paddingBottom: 0 };

    return (
      <div id="account-selection">
        <div className="mega-container">
          <section className="page-title-wrap">
            <article className="text-cell">
              <IconHeader
                variant="pageHeader"
                headerText="Is this distribution due to the following?"
              />
              <IconSubheader
                variant="subheading"
                subheader="Select one that may apply to you."
              />
            </article>
          </section>
          <div>
            <section
              className="form-sec-2col"
              style={{ paddingBottom: 10, paddingTop: 30 }}
            >
              <article className="col-form" style={articleStyle}>
                <div className="account-types">
                  {distributionReasons.map((type) => (
                    <SelectBox
                      label={type.label}
                      description={type.description}
                      key={type.key}
                      items={type.items}
                      ordered={type.ordered}
                      displayChevron={true}
                      onSelect={() => this._setDistributionReason(type.key)}
                      isSelected={
                        this.state.distributionSpecialReason === type.key
                      }
                    />
                  ))}
                </div>
              </article>
            </section>
            <section className="form-sec-2col">
              <article className="col-form">
                <div className="submit-row btn-row">
                  <Button
                    onClick={() =>
                      this.props.goToNamedStep!("distributionType")
                    }
                    name="cancel"
                    btnLabel="Go Back"
                    color="cancel"
                  />
                  <Button
                    style={{ marginLeft: 10 }}
                    name="action"
                    disabled={!this.state.distributionSpecialReason}
                    onClick={() =>
                      this.props.goToNamedStep!("distributionFederalTax")
                    }
                  />
                </div>
              </article>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default DistributionReason;
